import React from "react";
import { useHistory } from "react-router-dom";
import classes from "./SideServicesApp.module.scss";

const ChatIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z" fill="white"/>
  </svg>
);

const SideServicesApp = ({ onClick, isLoading = false }) => {
  const history = useHistory();

  const handleClick = () => {
    onClick();
    history.push("/chat");
  };

  return (
    <button
      disabled={isLoading}
      className={classes.sideServiceApp}
      onClick={handleClick}
    >
      <span className={classes.verticalText}>Chat with us</span>
      <span className={classes.chatIcon}>
        <ChatIcon />
      </span>
    </button>
  );
};

export default SideServicesApp;
